exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".youtube--2Ove1 {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tz-index: -1;\n}", ""]);

// Exports
exports.locals = {
	"youtube": "youtube--2Ove1"
};